import { useBranding } from '@blimo/ui';

export const DEFAULT_APP_NAME = 'BLIMO Portal';

/** "<Kurzname> Portal" aus dem Laufzeit-Branding (Standard: BLIMO Portal). */
export function useAppName() {
  const { short_name: shortName } = useBranding();
  return shortName ? `${shortName} Portal` : DEFAULT_APP_NAME;
}
